// Add your custom JS here.

import initCDCStepsModal from "./modules/cdc-steps-modal";
import initCDCGalleryGlightbox from "./modules/cdc-gallery-glightbox-init";
import initBloccoNormativaRegionale from "./modules/cdc-mappa-svg-normativa";
import initHomeFeaturedSlider from "./modules/home-slider-featured";
import initCoopSearchPopover from "./modules/coop-search-popover";

document.addEventListener("DOMContentLoaded", () => {

    // Inizializza il modal degli step della cooperativa di comunità
    // Il parametro è l'ID dello script JSON contenente i dati degli step
    initCDCStepsModal("cdc-steps-data");

    // Inizializza GLightbox per la galleria immagini
    initCDCGalleryGlightbox(".glightbox-item");

    // Inizializza il blocco Normativa Regionale
    initBloccoNormativaRegionale();

    // Inizializza lo slider dei contenuti in evidenza nella home
    initHomeFeaturedSlider();

    // Inizializza la popover informativa del campo ricerca cooperative
    initCoopSearchPopover();

});
